/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_InvitationsInputs */

const en_nav_invitations = /** @type {(inputs: Nav_InvitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invitations`)
};

/**
* | output |
* | --- |
* | "Invitations" |
*
* @param {Nav_InvitationsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_invitations = /** @type {((inputs?: Nav_InvitationsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_InvitationsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_invitations(inputs)
});